import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=2d4da2c8&"
import script from "./Profiles.vue?vue&type=script&lang=ts&"
export * from "./Profiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports